import script from "./TrainingList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__